
export const rounds = {
  title: "Supported Currencies and Rounding Rules",
  columns: {
    currency: "Supported currencies",
    iso: "ISO code",
    location: "Location where it is used",
    minPrice: "Minimum Net Price",
    roundTo: "Gross price rounded up to closest of these potential last digits"
  }
};
